import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const apiUrl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class PositionsService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  constructor(private http: HttpClient) { }

  index(id): Observable<any> {
    let query = '';
    if (id != 'null') {
      query = '?branch_office=' + id;

    }
    return this.http.get<any>(apiUrl + 'positions', this.httpOptions);
  }

  create(position: any): Observable<any> {
    return this.http
      .post<any>(apiUrl + 'positions', position, this.httpOptions);
  }

  update(position: any, id: any): Observable<any> {
    return this.http
      .put<any>(apiUrl + 'positions/' + id, position, this.httpOptions);
  }

  show(id: any): Observable<any> {
    return this.http.get<any>(apiUrl + 'positions/' + id, this.httpOptions);
  }
}
